export default __webpack_public_path__ + "static/media/camionAljibe.61cf109d.png";